import { LayoutHome } from "../layout/LayoutHome";
import { pathTeam1 } from "./team1Router";
import { pathTeam2 } from "./team2Router";
import { pathTeam3 } from "./team3Router";
import { pathTema4 } from "./tema4Router";
import { pathTema5 } from "./tema5Router";
import { pathTeam6 } from "./tema6Router";
import { pathTeam7 } from "./tema7Router";
import { pathTeam8 } from "./tema8Router";
import { pathTeam9 } from "./tema9Router";

export const pathPrivate = {
	root: "/",
};

const getRequestPrivateRoute = async (data) => {
	// const isLogged = localStorage.getItem("token");
	// if (!isLogged) {
	// 	return redirect("auth");
	// }
	// localStorage.clear();
	return true;
};

export const routePrivate = {
	path: pathPrivate.root,
	element: <LayoutHome />,
	loader: getRequestPrivateRoute,
	children: [
		pathTeam1,
		pathTeam2,
		pathTeam3,
		pathTema4,
		pathTema5,
		pathTeam6,
		pathTeam7,
		pathTeam8,
		pathTeam9,
	],
};
